// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eyebrow-pill {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.07em;
  text-transform: uppercase;
  color: #EE5B43;
  background: rgba(238, 91, 67, 0.1);
  padding: 5px 14px;
  border-radius: 20px;
  margin-bottom: 1.25rem;
}

.precision-h2 {
  font-size: 28px;
  font-weight: 700;
  line-height: 1.2;
  margin: 0 0 0.4rem;
  color: var(--ink);
}

.precision-h2-accent {
  display: block;
  color: #EE5B43;
}

.precision-rule {
  width: 40px;
  height: 3px;
  background: #EE5B43;
  border-radius: 2px;
  margin: 1rem 0 1.25rem;
}

.precision-body {
  font-size: 15.5px;
  line-height: 1.75;
  color: #555;
  margin: 0 0 1rem;
}

.precision-body strong {
  color: var(--ink);
  font-weight: 700;
}

.precision-stats {
  display: flex;
  gap: 12px;
  margin-top: 1.75rem;
}

.precision-stat {
  flex: 1 1;
  padding: 14px 16px;
  background: #f7f6f3;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.07);
}

.precision-stat-n {
  font-size: 22px;
  font-weight: 700;
  color: #EE5B43;
  line-height: 1;
}

.precision-stat-l {
  font-size: 12px;
  color: #888;
  margin-top: 5px;
  line-height: 1.4;
}

.precision-note {
  font-size: 15.5px;
  font-style: italic;
  line-height: 1.75;
  color: #555;
  margin: 1.25rem 0 0;
}

.precision-visual {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 50%;
}

/* .section-illustration est gérée par global.css */

/* ───────── Responsive : tablette, contenu centré ───────── */
@media (max-width: 768px) {
  .precision-h2 {
    font-size: 22px;
  }

  .precision-stats {
    flex-direction: row;
    gap: 10px;
  }

  .precision-stat {
    padding: 12px 10px;
  }

  .precision-text {
    text-align: center;
  }

  .eyebrow-pill {
    margin-left: auto;
    margin-right: auto;
  }

  .precision-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .precision-stats {
    justify-content: center;
  }
}

/* ───────── Responsive : mobile, contenu centré ───────── */
@media (max-width: 480px) {
  .precision-text {
    text-align: center;
  }

  .eyebrow-pill {
    margin-left: auto;
    margin-right: auto;
  }

  .precision-rule {
    margin-left: auto;
    margin-right: auto;
  }

  .precision-stats {
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    gap: 10px;
  }

  .precision-stat {
    flex-grow: 0;
    flex-shrink: 0;
    flex-basis: calc(50% - 5px);
    max-width: calc(50% - 5px);
    text-align: center;
  }
}

@media (max-width: 360px) {
  .precision-h2 {
    font-size: 20px;
  }

  .precision-body {
    font-size: 14px;
  }

  .precision-stat-n {
    font-size: 19px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/organisms/PrecisionSection/PrecisionSection.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,kCAAkC;EAClC,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA,mDAAmD;;AAEnD,8DAA8D;AAC9D;EACE;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,SAAS;EACX;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,uBAAuB;EACzB;AACF;;AAEA,4DAA4D;AAC5D;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,eAAe;IACf,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,YAAyB;IAAzB,cAAyB;IAAzB,2BAAyB;IACzB,0BAA0B;IAC1B,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".eyebrow-pill {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 12px;\n  font-weight: 600;\n  letter-spacing: 0.07em;\n  text-transform: uppercase;\n  color: #EE5B43;\n  background: rgba(238, 91, 67, 0.1);\n  padding: 5px 14px;\n  border-radius: 20px;\n  margin-bottom: 1.25rem;\n}\n\n.precision-h2 {\n  font-size: 28px;\n  font-weight: 700;\n  line-height: 1.2;\n  margin: 0 0 0.4rem;\n  color: var(--ink);\n}\n\n.precision-h2-accent {\n  display: block;\n  color: #EE5B43;\n}\n\n.precision-rule {\n  width: 40px;\n  height: 3px;\n  background: #EE5B43;\n  border-radius: 2px;\n  margin: 1rem 0 1.25rem;\n}\n\n.precision-body {\n  font-size: 15.5px;\n  line-height: 1.75;\n  color: #555;\n  margin: 0 0 1rem;\n}\n\n.precision-body strong {\n  color: var(--ink);\n  font-weight: 700;\n}\n\n.precision-stats {\n  display: flex;\n  gap: 12px;\n  margin-top: 1.75rem;\n}\n\n.precision-stat {\n  flex: 1;\n  padding: 14px 16px;\n  background: #f7f6f3;\n  border-radius: 8px;\n  border: 1px solid rgba(0, 0, 0, 0.07);\n}\n\n.precision-stat-n {\n  font-size: 22px;\n  font-weight: 700;\n  color: #EE5B43;\n  line-height: 1;\n}\n\n.precision-stat-l {\n  font-size: 12px;\n  color: #888;\n  margin-top: 5px;\n  line-height: 1.4;\n}\n\n.precision-note {\n  font-size: 15.5px;\n  font-style: italic;\n  line-height: 1.75;\n  color: #555;\n  margin: 1.25rem 0 0;\n}\n\n.precision-visual {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1 1 50%;\n}\n\n/* .section-illustration est gérée par global.css */\n\n/* ───────── Responsive : tablette, contenu centré ───────── */\n@media (max-width: 768px) {\n  .precision-h2 {\n    font-size: 22px;\n  }\n\n  .precision-stats {\n    flex-direction: row;\n    gap: 10px;\n  }\n\n  .precision-stat {\n    padding: 12px 10px;\n  }\n\n  .precision-text {\n    text-align: center;\n  }\n\n  .eyebrow-pill {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .precision-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .precision-stats {\n    justify-content: center;\n  }\n}\n\n/* ───────── Responsive : mobile, contenu centré ───────── */\n@media (max-width: 480px) {\n  .precision-text {\n    text-align: center;\n  }\n\n  .eyebrow-pill {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .precision-rule {\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .precision-stats {\n    flex-direction: row;\n    flex-wrap: wrap;\n    justify-content: center;\n    gap: 10px;\n  }\n\n  .precision-stat {\n    flex: 0 0 calc(50% - 5px);\n    max-width: calc(50% - 5px);\n    text-align: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .precision-h2 {\n    font-size: 20px;\n  }\n\n  .precision-body {\n    font-size: 14px;\n  }\n\n  .precision-stat-n {\n    font-size: 19px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
